import React from "react";
import "./rightside.css";
import { Link, NavLink } from "react-router-dom";
import banner from "../../images/banner1.png";
import Post from "../../components/post/Post";
import banner1 from "../../images/banner2.png";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { baseLocal, baseUrl } from "../../context/BaseUrl";
// import { useParams } from 'react-router-dom';
// import Rating from '../rating/Rating';
import SideBarContext from "../../context/SideBarContext";

const Rightside = () => {
  const [Data, setData] = useState(false);
  const [Data2, setData2] = useState(false);
  const [Data3, setData3] = useState(false);
  const [Data4, setData4] = useState(false);

  const {adBanners} = useContext(SideBarContext)

  async function fetchData() {
    const response = `${baseUrl}/user/vacancy/recentvacancies`;
    // const response = `${baseUrl}/user/vacancy/allvacancies?key=&limit=8`;
    const response2 = `${baseLocal}/user/institute/getsidebarinstitute`;
    const response3 = `${baseUrl}/user/sidebar`;
    const response4 = `${baseUrl}/user/institute/getfeaturedinstitute`;

    const getVacancy = axios.get(response);
    const getInstitute = axios.get(response2);
    const getFeaturedInstitute = axios.get(response4);
    const getBanner = axios.get(response3);

    axios.all([getVacancy, getInstitute, getBanner, getFeaturedInstitute]).then(
      axios.spread((...allData) => {
        const allVacancyList = allData[0].data;
        const allInstituteList = allData[1].data;
        const allFeaturedInstituteList = allData[3].data;
        const allBanner = allData[2].data;
        // console.log("getVacancy________________", getVacancy);
        setData(allVacancyList);
        setData2(allInstituteList);
        setData4(allFeaturedInstituteList);
        setData3(allBanner);
      })
    );
  }

 
  useEffect(() => {
    fetchData();
  }, []);

  return (
    Data &&
    Data2 &&
    Data3 &&
    Data4 && (
      <div className="sidebar px-0">
        {/* <Rating /> */}
        <div className="heading">
          <h4>Top Featured Institute</h4>
          <hr />
        </div>
        <ul className="instname list-unstyled">
          {Data4.map((item, index) => (
            <li key={index} className="text-capitalize">
              <Link to={`/institute/${item._id}`}> {item.name}</Link>
            </li>
          ))}
        </ul>

        <div className="banner">
          <a href={adBanners.top_sidebar.link}>
            <img src={adBanners.top_sidebar.banner} alt="banner" />
          </a>
        </div>
        <div className="heading">
          <h4>Top Viewed Institute</h4>
          <hr />
        </div>
        <ul className="instname list-unstyled">
          {Data2.map((item, index) => (
            <li key={index} className="text-capitalize">
              <Link to={`/institute/${item._id}`}> {item.name}</Link>
            </li>
          ))}
        </ul>
        <div className="banner">
          <a href={adBanners.mid_sidebar.link}>
            <img src={adBanners.mid_sidebar.banner} alt="banner" />
          </a>
        </div>

        <div className="heading">
          <h4>Recent Jobs</h4>
          <hr />
        </div>
        <ul className="instname list-unstyled">
          {Data.map((item, index) => (
            <li key={index} className="text-capitalize">
              <Link to={`/vacancy-detail/${item._id}`}>{item.name}</Link>
            </li>
          ))}
        </ul>
        <div className="banner">
          <a href={adBanners.bottom_sidebar.link}>
            <img src={adBanners.bottom_sidebar.banner} alt="banner" />
          </a>
        </div>
      </div>
    )
  );
};

export default Rightside;
